import { IconOfficeComponent } from './IconOffice.styled';

const IconOffice = () => {
  return <IconOfficeComponent />;
};

export default IconOffice;
